import React, { useState, useEffect } from "react";

import { getUserInfo } from "../../../api/usercall";
import Icon from "../../../common/components/Icon";

import individualTabs from "../tabs/individualTabs";
import businessTabs from "../tabs/businessTabs";

import PersonalInfo from "../tabs/PersonalInfo";
import AddressInfo from "../tabs/AddressInfo";
import GeneralInfo from "../tabs/GeneralInfo";
import AboutCompany from "../tabs/AboutCompany";
import ContactsInfo from "../tabs/ContactsInfo";
import DesignForm from "../tabs/DesignForm";

import { t } from "i18next";

function Settings({ setActiveTab }) {
    const [activeTabV, setActiveTabV] = useState("personal");
    const [userInfo, setUserInfo] = useState(null);
    const [companyInfo, setCompanyInfo] = useState(null);
    const [, setLocations] = useState([]);
    const [description, setDescription] = useState(companyInfo?.about?.text || "");
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const data = await getUserInfo();
                setUserInfo(data.user);
                setLocations(data.locations);
                setCompanyInfo(data.company_info);
                if (data.user.user_type === "business") {
                    setActiveTabV("general");
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };
        fetchUserData();
    }, []);

    const handleDescriptionChange = (event) => {
        if (!event || !event.target) return;
        const value = event.target.value.trimStart();
        setDescription(value);
        localStorage.setItem("description", value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmitted(true);
        if (!description.trim()) return;
    };

    const tabs = userInfo?.user_type === "individual"
        ? individualTabs(activeTabV, setActiveTabV)
        : businessTabs(activeTabV, setActiveTabV);

    return (
        <div className="w-full">
            <Icon src="backicon" onClick={() => setActiveTab(null)} className="block md:hidden fixed left-5 top-[23px] cursor-pointer z-[102]" />

            <div className="bg-white rounded-2xl overflow-hidden">
                {/* Tab navigation */}
                <div className="border-b border-gray-100 px-4 overflow-x-auto">
                    <div className="flex gap-1 py-3 min-w-max">
                        {tabs}
                    </div>
                </div>

                {/* Tab content */}
                <div className="p-6">
                    {activeTabV === "personal" && userInfo && <PersonalInfo userInfo={userInfo} />}
                    {activeTabV === "address" && <AddressInfo />}
                    {activeTabV === "general" && <GeneralInfo companyInfo={companyInfo} userInfo={userInfo} />}
                    {activeTabV === "about" && (
                        <AboutCompany
                            handleSubmitProp={handleSubmit}
                            handleDescriptionChangeProp={handleDescriptionChange}
                            isSubmitted={isSubmitted}
                            description={description}
                        />
                    )}
                    {activeTabV === "contacts" && <ContactsInfo companyInfo={companyInfo} userInfo={userInfo} />}
                    {activeTabV === "design" && <DesignForm companyInfo={companyInfo} />}
                </div>
            </div>
        </div>
    );
}

export default Settings;
